import 'vue-select/dist/vue-select.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from 'vue'
import vSelect from 'vue-select'
import Notifications from 'vue-notification'
import Multiselect from 'vue-multiselect'
import VueObserveVisibility from 'vue-observe-visibility'
import XSidebarMenuItem from './components/XSidebarMenuItem'
import XSidebarMenuDropdown from './components/XSidebarMenuDropdown'

// Global filters
import './filters'

// 3rd party components
Vue.component('multiselect', Multiselect)
Vue.component('v-select', vSelect)
Vue.component('v-sidebar-menu-item', XSidebarMenuItem)
Vue.component('v-sidebar-menu-dropdown', XSidebarMenuDropdown)
Vue.use(Notifications)
Vue.use(VueObserveVisibility)